skrilla.directive('contestReports',function() {
    return {
        templateUrl: 'directives/contestReports/contestReports.html',
        scope: {
            contest: "="
        },
        controller: function($scope, searchService, paginationService, queryService){
            if($scope.contest.state === "COMPLETED"){
                searchService.get("unknown/contests/daily/" + $scope.contest.contestId + "/report").then(function(response){
                    $scope.report = response.data;
                });
            }
        }
    };
});
